import {Component} from '@angular/core';
import {NavService} from '../service/nav.service';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ErrorStateMatcher} from '@angular/material/core';
import {NavBranch} from '../model/nav-branch';
import {NavReportModel} from '../model/nav-report';
import {MatSnackBar} from '@angular/material/snack-bar';
import {BehaviorSubject} from 'rxjs';
import {ExportGridService} from 'src/app/shared/service/files/export-grid.service';
import {DatePipe} from '@angular/common';
import {NavMappingModel} from '../model/nav-mapping';

@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    standalone: false
})

  export class FileUploadComponent {
    loading = new BehaviorSubject<boolean>(false);
    branchName: string = '';
    file1: File | undefined;
    file2: File | undefined;
    file3: File | undefined;
    datasources: NavBranch[] = [];
    navUploadForm: FormGroup = this._formBuilder.group({});
    dataSourceFormControl: FormControl = new FormControl('', [Validators.required, Validators.min(1)]);
    dataSourceErrorStateMatcher: ErrorStateMatcher = new ErrorStateMatcher();
    file1FormControl: FormControl = new FormControl('', [Validators.required]);
    file2FormControl: FormControl = new FormControl('', [Validators.required]);
    fileMappingFormControl: FormControl = new FormControl('', [Validators.required]);
    IsEmptyNavReportData: boolean = false;
    IsEmptyNavMappingData: boolean = false;
    NavBranchId: number = -1;
    DataSourceId: number = -1;
    constructor(
      private navService: NavService,
      private _formBuilder: FormBuilder,
      protected exportGridService: ExportGridService,
      protected datePipe: DatePipe,
      private _snackBar: MatSnackBar) {
        this.dataSourceFormControl = new FormControl('', [Validators.required, Validators.min(1)]);
        this.file1FormControl = new FormControl('', [Validators.required]);
        this.file2FormControl = new FormControl('', [Validators.required]);
        this.fileMappingFormControl = new FormControl('', [Validators.required]);
        this.file1FormControl.disable();
        this.file2FormControl.disable();
        this.fileMappingFormControl.disable();
        this.getDataSources();
    }

    public getDataSources() {
      this.navService.getNavBranches().subscribe(
        (data: any) => {
          if (data?.items) {
            this.datasources = data.items as NavBranch[];
          }
        }
      );
    }

    public onDataSourceSelected() {
      const branch = this.datasources.find(item => item.id === this.dataSourceFormControl.value);
      this.branchName = branch ? `'${branch.branchName}'` : '';
      this.file1FormControl.enable();
      this.file2FormControl.enable();
      this.fileMappingFormControl.enable();
    }

    onFileSelected(event: Event, type: 'file1' | 'file2' | 'file3') {
      const input = event.target as HTMLInputElement;
      const file = input.files?.[0];
      if (file) {
        if (type === 'file1') this.file1 = file;
        if (type === 'file2') this.file2 = file;
        if (type === 'file3') this.file3 = file;
      }
    }

    uploadNavReportFiles() {
      if (!this.file1 || !this.file2 || this.dataSourceFormControl.invalid) {
        return;
      }
    
      const formData = new FormData();
      formData.append('previousFile', this.file1);
      formData.append('currentFile', this.file2);
      const dataSource = this.datasources.find(s => s.id === this.NavBranchId);
      if (dataSource?.sourceId !== undefined && dataSource?.sourceId !== null) {
        formData.append('dataSourceId', dataSource?.sourceId.toString());
      }
    
      this.loading.next(true);
    
      this.navService.uploadNavReportFiles(formData).subscribe({
        next: (result) => {
          if(result) {
            this.file1 = undefined;
            this.file2 = undefined;
            this.file1FormControl.reset();
            this.file2FormControl.reset();
            this._snackBar.open(`Upload successful for ${this.branchName} of Nav Reports.`, 'Dismiss');
            this.loading.next(false);
          }
        },
        error: (err) => {
          this._snackBar.open(`Upload failed for ${this.branchName} of Nav Reports: ${err}`, 'Dismiss');
          this.loading.next(false);
        }
      });
    }

    clearNavInputFileElements(){
      [this.file1, this.file2, this.file3] = [undefined, undefined, undefined];
      [this.file1FormControl, this.file2FormControl, this.fileMappingFormControl].forEach(fc => fc.reset());
    }

    uploadNavMappingFile() {
      if (!this.file3 || this.dataSourceFormControl.invalid) {
        return;
      }
      const formData = new FormData();
      formData.append('navMappingInputFile', this.file3);
      this.loading.next(true);
      this.navService.uploadNavMappingFile(formData).subscribe({
        next: (result) => {
          if(result) {
            this.file3 = undefined;
            this.fileMappingFormControl.reset();
            this._snackBar.open(`Upload successful for ${this.branchName} of  Nav Mappings.`, 'Dismiss');
            this.loading.next(false);
          }
        },
        error: (err) => {
          this._snackBar.open(`Upload failed for ${this.branchName} of Nav Mappings: ${err}`, 'Dismiss');
          this.loading.next(false);
        }
      });
    }

    onReportDownload(): void {
      if (this.dataSourceFormControl.value != undefined && this.dataSourceFormControl.value > 0) {
        this.loading.next(true);
        this.DataSourceId = this.datasources.find(s => s.id === this.NavBranchId)!.sourceId;
        this.navService.getNavReport(
          this.DataSourceId,this.NavBranchId)
          .subscribe((data) => {
              this.clearNavInputFileElements();
              this.loading.next(false);
              if(data.length > 0){
                this.IsEmptyNavReportData = false;
                this.exportGridService.downloadDataSource(
                  data,
                  'Nav-Report',
                  (data) => {
                    const record = data as NavReportModel;
                    return {
                      'PostingDate': record?.postingDate,
                      'DocumentType': record?.documentType,
                      'DocumentDate': this.datePipe.transform(record?.documentDate, 'M/d/yyyy'),
                      'DocumentNo': record?.documentNo,
                      'AccountType': record?.accountType,
                      'ExternalDocumentNo': record?.externalDocumentNo,
                      'Description': record?.description,
                      'CurrencyCode': record?.currencyCode,
                      'Amount': record?.amount,
                      'Region': record?.region,
                      'TradingPartner': record?.tradingPartner,
                      'ExchangeRate': record?.exchangeRate,
                      'Dept': record?.dept,
                      'TripId': record?.tripId,
                      'SegmentCode': record?.segmentCode,
                      'BalAccountNo': record?.balAccountNo,
                      'BalAccountType': record?.balAccountType,
                      'DueDate': this.datePipe.transform(record?.dueDate, 'M/d/yyyy')
                    }
                  }
                )
              }else{
                this.IsEmptyNavReportData = true;
              }
            });
       }
     }

    onMappingDownload(): void {
      if (this.dataSourceFormControl.value != undefined && this.dataSourceFormControl.value > 0) {
        this.loading.next(true);
        this.navService.getNavGlMapping(this.NavBranchId)
          .subscribe((data) => {
              this.clearNavInputFileElements();
              this.loading.next(false);
              if(data.length > 0){
                this.IsEmptyNavMappingData = false;
                this.exportGridService.downloadDataSource(
                  data,
                  'Nav-Mapping',
                  (data) => {
                    const record = data as NavMappingModel;
                    return {
                      'SourceId': record?.sourceId,
                      'NavBranchId': record?.navBranchId,
                      'GlNo': record?.glNo,
                      'GlName': record?.glName,
                      'NavGl': record?.navGl,
                      'NavGlDescription': record?.navGlDescription,
                      'NavCompany': record?.navCompany,
                      'AccountType': record?.accountType,
                      'TradingPartner': record?.tradingPartner,
                      'AgressoSummary': record?.agressoSummary,
                      'Id': record?.id,
                      'IsDeleted': record?.isDeleted
                    };
                  }
                )
              }
              else{
                this.IsEmptyNavMappingData = true;
              }
            });
      }
    }
  }
